import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-payment',
  styles: [`
    .payment-container {
      width: 100%;
      border-radius: var(--card-border-radius);
      background-color: var(--header-color);
      margin-bottom: 16px;
      display: flex;
      gap: 10px;
      flex-direction: column;
    }
    
    p{
      font-size: 15px;
      margin-bottom: 0;
    }

    .card-info{
      background-color:  var(--dashboard-bg);
      width: 100%;
      padding: 10px;
      border-radius: var(--card-border-radius);
      display: flex;
      gap: 10px;
      border: solid 1px var(--border-light);
    }

    .material-symbols-outlined{
      color: var(--text-muted-light);
      display: flex;
      align-items: center;
    }

    .credit-info{
      display: flex;
      flex-direction: column;
    }

    .title{
      font-size: 15px;
      font-weight: 400;
    }

    .credit-number{
      font-size: 11px;
      color: var(--text-muted-light);
    }
    `],
  template: `
    <div class="payment-container">
      <p>Payment Method</p>
      <div class="card-info">
        <span class="material-symbols-outlined">credit_card</span>
        <div class="credit-info">
          <span class="title">Credit card</span>
          <span class="credit-number">{{maskCardNumber('5678 6987 9887 9980')}}</span>
        </div>
      </div>
    </div>
  `,
  standalone: false
})

export class PaymentMethodComponent extends FieldType {

  get control() {
    return this.formControl as any;
  }

  maskCardNumber(cardNumber: string): string {
    const cleaned = cardNumber.replace(/\s+/g, '');

    const lastFour = cleaned.slice(-4);

    return '**** **** **** ' + lastFour;
  }

}